export enum ConfirmationModalType {
  DANGER = 'danger',
  PRIMARY = 'primary',
}

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  okText?: string;
  cancelText?: string;
  type?: ConfirmationModalType;
}
